module.exports = __webpack_public_path__ + "img/resized-APP-0002-2.e6af5005.png";